// extracted by mini-css-extract-plugin
export default {"button":"Button_button__tLau-","full_width":"Button_full_width__008zP","disabled":"Button_disabled__2YKgY"};